export default __webpack_public_path__ + "static/media/sideNavLogo.22ec52e5.png";